import React from 'react'

import type { IconComponent } from '@fourthwall/components'
import { GoogleAnalyticsIcon } from '@fourthwall/icons'

import type { AnalyticsExternalSource } from '../../types'

type AnalyticsExternalSourceIconProps = {
  externalSource?: AnalyticsExternalSource
  size?: number
}

const externalSourceIconsMap: Record<AnalyticsExternalSource, IconComponent> = {
  googleAnalytics: GoogleAnalyticsIcon,
}

const getAnalyticsExternalSourceIcon = (externalSource?: AnalyticsExternalSource) =>
  externalSource ? externalSourceIconsMap[externalSource] : undefined

export const AnalyticsExternalSourceIcon = ({
  externalSource,
  size = 16,
}: AnalyticsExternalSourceIconProps) => {
  if (!externalSource) return null

  const ExternalSourceIcon = getAnalyticsExternalSourceIcon(externalSource)

  if (!ExternalSourceIcon) return null

  return <ExternalSourceIcon height={size} width={size} />
}
